'use client'

import type { AnalyticsSection } from '../AnalyticsEventType'

export const getSectionFromElement = (element: HTMLElement): AnalyticsSection => {
    if (element.closest('[role="dialog"]') || element.closest('[aria-modal="true"]') || element.closest('.modal')) {
        return 'modal'
    }
    if (element.closest('nav') || element.closest('[role="navigation"]')) {
        return 'nav'
    }
    return 'body'
}
